import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'


export class TViteForwarder extends React.Component<Tgcc.BaseProps, any>{    
    componentWillMount(){
        browserHistory.replace(Tgcc.Routes.TVite(this.props.location.query.cowaction));
    }
    render(){
        return null;
    }
}
